import postWithResponse from '@services/api/common/postWithResponse';
import appConfig from '@configs/appConfig';
import { billingLinks } from '@constants/appRoutes';

export const createLink = data =>
  postWithResponse(appConfig.baseUrl.concat(billingLinks), data);
